export default {
    'contact': {
        'caption': `Please use the form to send a message or contact us through the relevant offices.`,
        'adress-1': `<h3 class="contact-adress__head">London Office (MAIN):</h3>
                    <p class="contact-adress__info">Minto International, Inc.<br>19 Cadogan Place<br>London SW1X 9SA UK<br>Tel: +44 (0)207 235 6274
                    <!--<br>email: enquiries@barbaraminto.com-->
                    </p>`,
        'adress-2': `<h3 class="contact-adress__head">Virginia Office:</h3>
                    <p class="contact-adress__info">
                        Minto International, Inc.
                        <br>215 Brooke Avenue. No. 609
                        <br>Norfolk, VA 23510 USA
                        <br>Tel: +1 757 425 4511
                        <!--<br>email: inquiries@barbaraminto.com-->
                    </p>`,
    }
}


// WEBPACK FOOTER //
// ./client/app/modules/site/contact/i18n/en.js